<div class="text-center p-4">
  @if (message) {
    <p class="mb-0">{{ message }}</p>
  }
  <div class="ajax-loading-image" role="status">
    @if (!message) {
      <span class="visually-hidden">Loading&hellip;</span>
    }
  </div>
</div>
